import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfoForCallersModalContent from '../components/pages/waiting-area/info-for-callers/content';

function WaitingAreaInfoForCallersModal(props) {
  const informationForCallersForm = useSelector((state) => state.waitingAreaReducer.informationForCallersForm);
  const dispatch = useDispatch();
  return (
    <div>
      <InfoForCallersModalContent
        updateOrView={props.updateOrView}
        informationForCallersForm={informationForCallersForm}
        waitingArea={props.waitingArea}
        dispatch={dispatch}
      />
    </div>
  );
}

export default WaitingAreaInfoForCallersModal;
